import axios, { AxiosInstance } from 'axios';

export class TrackingHttpClient {
    private baseUrl: string;

    private httpClient: AxiosInstance;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;

        this.httpClient = axios.create();
    }

    public async sendDataToSap(userData: FormData): Promise<void> {
        return this.httpClient.post(`${this.baseUrl}/os/c/stats.do`, userData);
    }
}
